import React, { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import { getIsLoggedIn } from '../../publicSession/selectors';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
var PortfolioReduxModule = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "portfolioredux" */
        './PortfolioReduxModule');
    });
});
export var LoadablePortfolioReduxModule = function () {
    var isLoggedIn = useSelector(getIsLoggedIn);
    var isMounted = useIsMounted();
    if (!isLoggedIn || !isMounted) {
        return null;
    }
    // prevent inside iframes
    if (typeof window !== 'undefined' && window.top !== window.self) {
        return null;
    }
    return (React.createElement(ErrorBoundary, { debugComponent: "LoadablePortfolioReduxModule" },
        React.createElement(Suspense, { fallback: null },
            React.createElement(PortfolioReduxModule, null))));
};
LoadablePortfolioReduxModule.displayName = 'LoadablePortfolioReduxModule';
export default LoadablePortfolioReduxModule;
//# sourceMappingURL=LoadablePortfolioReduxModule.js.map